// Modules
import { ViewChild, Renderer2, ViewChildren, QueryList, ViewContainerRef } from '@angular/core'; // AfterViewInit
import { Component, OnInit, Input, EventEmitter, Output, ElementRef } from '@angular/core';
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { TooltipPosition } from '@angular/material/tooltip';

// Components
import { SchoolsDistrictsModalComponent } from '../schools-districts-modal/schools-districts-modal.component';

// Services/Models
import { ApiSchoolDistrictsService } from '../../../../service/api-school-districts.service';
import { BaseLocalStorageService } from 'src/app/service/base-local-storage.service';
import { ORGANIZATION, PartyRoleTypes, POSTAL_ADDRESSES, School } from 'src/app/model/school.model';
import { OrganizationService } from '../../../common-components/organizations/service/organization.service';
import { County } from 'src/app/model/county';
import { Region } from '../../../../model/region.model';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { SchoolSearchDistrictsResult } from './model/SchoolSearchDistrictsResult.model';
import { HttpClient } from '@angular/common/http';
import { CreateSchoolDistrictsComponent } from '../create-school-districts/create-school-districts.component';
import { EditSchoolDistrictsComponent } from '../edit-school-districts/edit-school-districts.component';
import { UtilityService } from 'src/app/service/utility.service';
import { AccessService } from 'src/app/component/navigation/service/access.service';

@Component({
    selector: 'app-msin-mat-table-districts',
    templateUrl: './msin-mat-table-districts.component.html',
    styleUrls: ['./msin-mat-table-districts.component.scss']
})
export class MsinMatTableDistrictsComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    @Output() onUpdateLabelEvent: EventEmitter<string> = new EventEmitter();
    @Output() onCheckCloseDialogEvent: EventEmitter<boolean> = new EventEmitter();
    @Output() onIsLoadingResultsEvent: EventEmitter<boolean> = new EventEmitter();
    @Output() onSearchErrorEvent: EventEmitter<string> = new EventEmitter();
    @Output() onRegionChangeEvent: EventEmitter<string> = new EventEmitter();
    @Output() onCreateEvent: EventEmitter<any> = new EventEmitter();

    @Input() searchParm: any = [{}];
    @Input() columnList!: string[];
    @Input() showViewIcon!: boolean;
    @Input() showPagination!: boolean;
    @Input() isLoadingResults: boolean = false;
    @Input() canClearFilter!: boolean;
    @Input() filterPlaceholder: string = '';
    @ViewChild('hoverTip') myHoverTip!: ElementRef;

    sortedData: SchoolSearchDistrictsResult[];

    // general properties
    txtSearchResultsTitle: string = '';
    baseLocalStorageService: any;
    dataSource!: MatTableDataSource<SchoolSearchDistrictsResult>;
    chosenCounties: County[] = [];
    chosenRegions: Region[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    displayedColumns: string[] = ['selectView', 'REGIONS.CODE', 'COUNTy.COUNTY_CODE', 'CODE', 'DISTRICTS', 'NCESDist'];
    formCtlSelectSchoolDistrict!: UntypedFormGroup;
    localStorageInfo$: Observable<any> = new Observable();
    myData!: School[];
    isLoading: boolean = false;
    httpClient: HttpClient; // used for export pdf

    schoolDistrict: SchoolDistrict;
    schoolDistrictsService: any;
    organizationService: any;
    partyId: any = [{}];
    myOrganization!: ORGANIZATION;
    postalAddresses: POSTAL_ADDRESSES[] = [];
    displayPostalAddresses: string[] = [];
    actualContactMechanisms: any = [];

    partyIdNum!: number;
    organizationId!: number;
    hoverVal: string = '';
    bShowHoverTip = false;
    bHideColID = true;

    region: string = '';
    regionName: string = ''; // fully qualified name
    districtCode: string = '';
    ncesCode: string = '';
    NCES: string = '';
    county: string = '';
    district: string = '';

    // Table results
    tableDataSource: MatTableDataSource<SchoolSearchDistrictsResult>;
    results: SchoolSearchDistrictsResult[] = [];

    // for hover over actions
    positionOptions: TooltipPosition[] = ['after', 'before', 'below', 'above', 'below', 'left', 'right'];
    position = new UntypedFormControl(this.positionOptions[3]);

    clickedRows: number[] = [];
    customHoverMessage: string = '';

    // CREATE props start here
    bCancelCreate: boolean = false;
    createBtnText: string = 'Create';

    // for shoppingcart
    currentSortValue = '';

    // security features setup
    featuresCheck = ['Create School Districts', 'Search School Districts'];
    featurePermissions: any;

    // dialog for create, options
    isOverflowEnabled = false;  
    
    constructor(
        schoolDistrictsService: ApiSchoolDistrictsService,
        organizationService: OrganizationService,
        _baseLocalStorageService: BaseLocalStorageService,
        private dialog: MatDialog,
        private http: HttpClient,
        private viewContainerRef: ViewContainerRef,
        private utilityService: UtilityService,
        private accessService: AccessService
    ) {
        this.schoolDistrictsService = schoolDistrictsService;
        this.organizationService = organizationService;
        this.baseLocalStorageService = _baseLocalStorageService;
        this.localStorageInfo$ = _baseLocalStorageService.myData$;
        this.httpClient = http;
    }

    compare(a: number | string, b: number | string, isAsc: boolean) {
        var retVal = (a < b ? -1 : 1) * (isAsc ? 1 : -1);
        console.log('comp returning:' + retVal);
        return retVal;
    }

    strCompare(a: string, b: string, isAsc: boolean) {
        /* let aComp: string = a.toLowerCase();
     let bComp: string = b.toLowerCase();
    */
        var retVal = b.localeCompare(a, 'en', { caseFirst: 'lower', ignorePunctuation: true, sensitivity: 'variant' });
        console.log('now comparing names:' + a + ' with ' + b + ' strCompare returning: ' + retVal);
        return retVal;
    }

    onFocus(e: MouseEvent, inStr: string, colNum: number) {
        this.bShowHoverTip = true;
        this.customHoverMessage = inStr;
        this.hoverVal = inStr;
    }

    onBlur(e: MouseEvent, colNum: number) {
        let xMin!: Number;
        let xMax!: Number;

        switch (colNum) {
            case 1:
                xMin = 355;
                xMax = 430;
                break;
            case 2:
                xMin = 395;
                xMax = 460;
                break;
        }
        this.bShowHoverTip = false;
    }

    delay(time: number) {
        return new Promise((resolve) => setTimeout(resolve, time));
    }

    isEmpty(obj: any) {
        return Object.keys(obj).length === 0;
    }

    getSpecificSchoolDistricts(bEmit: boolean) {
        console.log('calling getSpecificSchoolDistricts at msinMatTable layer, with parm:' + bEmit);
        this.isLoadingResults = true;
        this.onIsLoadingResultsEvent.emit(this.isLoadingResults);
        const searchParmEntries = Object.values(this.searchParm);
        const countiesInput = Object.values(this.chosenCounties);
        const regionsInput = Object.values(this.chosenRegions);
        const districtsInput = Object.values(this.chosenSchoolDistricts);
        console.log('now at msintabledistrict, the county is');
        console.log(this.chosenCounties);
        if (this.chosenCounties) {
            this.searchParm.chosenCounties = this.chosenCounties;
        }
        if (this.chosenRegions) {
            this.searchParm.chosenRegions = this.chosenRegions;
        }
        let iRowIndex = -1;
        console.log('final search parm:');
        console.log(this.searchParm);
        this.schoolDistrictsService.getSpecificSchoolDistricts(this.searchParm).subscribe({
            next: (res: any) => {
                const mySchoolDistricts: SchoolDistrict[] = res;
                if (res.schoolDistricts) {
                    res.schoolDistricts.forEach((y: SchoolDistrict) => {
                        iRowIndex = iRowIndex + 1;
                    });
                } else {
                    this.onSearchErrorEvent.emit('No school results. Please check your input.');
                }
                this.results = res.schoolDistricts;
                this.isLoadingResults = false;
                this.onIsLoadingResultsEvent.emit(this.isLoadingResults);
            },
            error: (err: any) => {
                this.onSearchErrorEvent.emit('error:' + err);
                console.log('error while getting school data: ' + err);
            },
            complete: () => {
                this.updateDataSource();

                // Display results
                this.isLoading = false;
            }
        });
    }

    updateDataSource() {
        setTimeout(() => {
            let dataSource = new MatTableDataSource<SchoolSearchDistrictsResult>();
            dataSource.data = this.results;
            dataSource.paginator = this.paginators?.toArray()[0];

            // Sort
            dataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'NAME', direction: 'asc' };
            dataSource.sort.active = defaultSort.active;
            dataSource.sort.direction = defaultSort.direction;
            dataSource.sort.sortChange.emit(defaultSort);
            dataSource.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);

            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.tableDataSource = dataSource;
            if (this.results?.length) {
                this.txtSearchResultsTitle = 'Search Results (' + this.results.length + ')';
            } else {
                this.txtSearchResultsTitle = 'Search Results';
            }
        });
    }

    getProperty = (obj: any, path: string) => (path.split('.').reduce((o, p) => o && (o || {})[p], obj) || '').toLowerCase();

    toggleShow(obj: any) {
        obj.SHOW = !obj.SHOW;
    }

    expandAll(array: any[]) {
        array.forEach((obj) => {
            obj.SHOW = true;
        });
    }

    announceSortChange(sortState: Sort) {
        console.log('announceSortChange called');
        console.log(sortState);
    }

    // likely will use this once roles management/authorization is implemented
    getPartyRoleTypesByCategory(body: any) {
        this.schoolDistrictsService.getPartyRoleTypeByCategory(body).subscribe({
            next: (res: any) => {
                const myPartyRoleTypeByCategory: PartyRoleTypes[] = res.partyRoleTypes;
            },
            error: (err: any) => {
                console.log('error while getting getPartyRoleTypesByCategory data');
            }
        });
    }

    ngOnInit(): void {
        this.formCtlSelectSchoolDistrict = new UntypedFormGroup({
            txtFilter: new UntypedFormControl(null, [Validators.required]),
            hoverTipObj: new UntypedFormControl(null)
        });

        this.getFeaturePermissions();
    }

    getFeaturePermissions() {
        try {
	        this.accessService.getFeatureAccessPromise(this.featuresCheck).then((res) => {
	            this.featurePermissions = res;
	        });
		} catch (Err) {
            console.log('error getting feature permission in msin-mat-table.component:' + Err);
        }
    }

   
    fnReset() {
        this.formCtlSelectSchoolDistrict.controls['txtFilter'].reset();

        this.searchParm = [];
        this.chosenCounties = [];
        this.chosenRegions = [];
        this.chosenSchoolDistricts = [];

        var origItemCount = 0;
        try {
            console.log('data source length:' + this.dataSource.data.length);
            origItemCount = this.dataSource.data.length;
        } catch (Err) {
            console.log('defaulting to 0');
            origItemCount = 0;
        }

        this.applyFilter();
    }

    get f() {
        return this.formCtlSelectSchoolDistrict.controls;
    }

    applyFilter(event?: Event) {
        let filterValue = '';

        if (event) {
            filterValue = (event.target as HTMLInputElement).value;
        }
        var origItemCount = 0;

        if (this.tableDataSource) {
            try {
                origItemCount = this.tableDataSource?.data?.length;
            } catch (Err) {
                console.log('error getting dataSourceLength:' + Err);
                origItemCount = 0;
            }
            if (origItemCount > 0) {
                this.tableDataSource.filter = filterValue.trim().toLowerCase();
            }
        }

        if (this.dataSource?.data) {
            try {
                origItemCount = this.dataSource.data.length;
                console.log('orig item count: ' + origItemCount);
            } catch (Err) {
                console.log('error getting dataSourceLength:' + Err);
                origItemCount = 0;
            }
            if (origItemCount > 0) {
                this.dataSource.filter = filterValue.trim().toLowerCase();
            }
        } else {
            console.log('filter thinks there is no data');
        }
    }

    openDialog(row: any) {
        const dialogRef = this.dialog.open(SchoolsDistrictsModalComponent, {
            width: '90%',
            height: '90%',
            data: row
        });
        dialogRef.afterClosed().subscribe((result) => {
            // this.ngOnInit();
            // this.onRegionChangeEvent.emit(result['REGIONS'])
        });
    }

    
    edit(row: any) {
        //    this.accountService.getAccount({ id: row.ID }).subscribe((x) => {
        //        let u: UserModel = x;

        const dialogRef = this.dialog.open(EditSchoolDistrictsComponent, {
            disableClose: true,
            width: '95%',
            height: '90%',
            data: row
            //,
            ///viewContainerRef: this.viewContainerRef
        });
        dialogRef.afterClosed().subscribe((result) => {
            console.log('passing result');
            console.log(result);
            this.fnInit(row);
			this.getSpecificSchoolDistricts(true);
            /*: UserModel) => {
          if (result != undefined) {
              let index = this.dataSource.data.findIndex((x) => x.ID === result.ID);
              if (index >= 0) {
                  this.dataSource.data[index].LOGIN_DETAIL_STATUS = result.LOGIN_DETAIL_STATUS;
                  this.dataSource.data[index].PERSON!.FIRST_NAME = result.PERSON?.FIRST_NAME;
                  this.dataSource.data[index].PERSON!.LAST_NAME = result.PERSON?.LAST_NAME;
                  this.dataSource.data[index].EMAIL_ADDRESS = result.EMAIL_ADDRESS;
                  this.dataSource.data[index].WORK_TITLE = result.WORK_TITLE;
                  this.dataSource.data[index].WORKS_FOR = result?.WORKS_FOR;
                  this.dataSource.data[index].SCHOOL_DISTRICTS = result.SCHOOL_DISTRICTS;
                  this.dataSource.data[index].REGION = result?.REGION;
                  this.dataSource.data[index].USER_ROLES = result?.USER_ROLES;
              }
          }
      });*/
        });
    }


    fnInit(row: any) {
        // set school object
        this.schoolDistrictsService.show(row['ID']).subscribe((res: SchoolDistrict) => {
            console.log('thisSchool: ');
            this.schoolDistrict = res;
            console.log(this.schoolDistrict);

            // set school data
            this.region = this.schoolDistrict.REGIONS.NAME || ''; //this.editData['REGION'];
            const regionShell = this.schoolDistrict.REGIONS; //this.editData['REGIONS'];

            const districtShell = this.schoolDistrict.DISTRICTS; // this.editData['SCHOOL_DISTRICT'];
            this.districtCode = this.schoolDistrict.CODE.toString(); //districtShell['CODE'].toString();
            const ncesShell = this.schoolDistrict.NCESDist; //this.editData['NCES'];
            this.ncesCode = this.schoolDistrict.NCESDist.toString() || '';
            this.NCES = this.schoolDistrict.NCESDist.toString();

            const districtOrganizationShell = this.schoolDistrict.ORGANIZATION.NAME; ////districtShell['ORGANIZATION'];

            var translateCounty = this.schoolDistrict.COUNTy.COUNTY_NAME; //(Object.values(this.editData['COUNTy'])?.toString()).split(',');
            this.county = translateCounty + ' (' + this.schoolDistrict.COUNTy.ID + ')'; // translateCounty[2] + " (" + translateCounty[3] + ")";
            this.district = this.schoolDistrict.DISTRICTS; // this.editData['DISTRICT'];

            // this.schoolDistrict = this.schoolDistrict.DISTRICTS; //this.editData['NAME'];

            /*  console.log("incomingData:" + this.region + "," + this.county + "," + this.district
        + "," + this.schoolType + "," + this.SSID
        + "," + this.CDSCode + "," + this.NCES
        + "," + this.schoolName
      ); */

            this.isLoading = false;

            // load party data
            if (this.schoolDistrict.ORGANIZATIONS_ID) {
                this.organizationId = this.schoolDistrict.ORGANIZATIONS_ID; //this.editData['ORGANIZATIONS_ID'];

                this.organizationService.show(this.organizationId).subscribe({
                    next: (res: any) => {
                        this.myOrganization = res.organization;
                        console.log('organization is: ' + Object.entries(this.myOrganization));
                        console.log('party ids are: ' + this.myOrganization.PARTIES_ID);
                        this.partyId = this.myOrganization.PARTIES_ID;

                        this.partyIdNum = parseInt(this.partyId);
                        // this.getPartyRoleTypesByCategory({ 'partyRoleCategoryType': 'ORGANIZATION' });

                        console.log('inbound organization id1 is: ' + this.organizationId);

                        console.log('my organization: ' + this.myOrganization.PARTIES_ID);
                    },
                    error: (err: any) => {
                        alert('Error while fetching the records');
                        console.log('error while getting organization data');
                    }
                });
            }
        });
    }


    fnCheckRow(row: School, ind: number) {
        return this.clickedRows.includes(ind);
    }

    fnCreate() {
        // this.onCreateEvent.emit();
        const dialogRef = this.dialog.open(CreateSchoolDistrictsComponent, {
            width: '100%',
            height: '70%',
            panelClass: 'largescreen-dialog',
            data: {isOverflowEnabled: this.isOverflowEnabled, isCreated: false},
            viewContainerRef: this.viewContainerRef
        });
        dialogRef.componentInstance.createdStatusChanged.subscribe((isCreated)=>{
            console.log('Parent received the change:', isCreated);
        })
        dialogRef.afterClosed().subscribe((result) => {
            // this.ngOnInit();
            // this.onRegionChangeEvent.emit(result['REGIONS'])
        });
    }
    toggleOverflow() {
        this.isOverflowEnabled = !this.isOverflowEnabled;
        console.log("toggling overflow in msinmattable");
      }
}
